import './DuplicateEmail_Page.css';
import Icons_Repository from '../Icons/Icons_Repository';
function DuplicateEmail_Page(){
    return (
        <div className='duplicate-email-page-container'>

        
            <div className="duplicate-email-page">
                <div className="duplicate-email-card">
                    <div className="duplicate-email-header">
                        <div className='duplicate-email-calendar-icon'>
                            <Icons_Repository iconName='alert_triangle' />
                        </div>
                        <h2 className="duplicate-email-title">Duplicate Email Detected</h2>
                    </div>
                    <div className='duplicate-email-body'>
                        <div className='duplicate-email-body-text'>
                            A duplicate email for this account was detected. Requesting you to immediately contact your recruiter regarding the same.
                        </div>
                    </div>
                    

                </div>
            </div>
        </div>
    )
}
export default DuplicateEmail_Page